<template>
  <div class="page-title">
    <h1>Biobá, produtos da natureza.</h1>
    <h2>Articulação comercial pela biodiversidade.</h2>
  </div>
</template>
<script>
export default {
}
</script>
<style lang="sass" scoped>
  .page-title
    text-align: center
    margin-bottom: 75px
    padding: 15px
    h1
      font-size: 20px
      font-weight: 600
    h2
      font-weight: 100
</style>
